import { render, staticRenderFns } from "./TabelaSelecaoTagFiltro.vue?vue&type=template&id=92941ce4&scoped=true"
import script from "./TabelaSelecaoTagFiltro.vue?vue&type=script&lang=js"
export * from "./TabelaSelecaoTagFiltro.vue?vue&type=script&lang=js"
import style0 from "./TabelaSelecaoTagFiltro.vue?vue&type=style&index=0&id=92941ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92941ce4",
  null
  
)

export default component.exports